export const PRE_ORDER_MESSAGE_TABLE = "preOrderMessages"
// Inverse-direction reads matter as much as forward: for a given preOrderId
// list its WhatsApp messages (recap), AND for a given messageId/chatId list
// the pre-orders linked to it (chat-page badges).
export const PRE_ORDER_MESSAGE_TABLE_SCHEMA =
  "id, companyId, preOrderId, messageId, chatId, syncId, deletedAt"
